import React, { useEffect, useState } from "react";
import { UserPlus, UserCheck } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function FollowButton({ slug }) {
  const { user } = useAuth();
  const [state, setState] = useState({ followers_count: 0, following_count: 0, is_following: false, is_self: false });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!slug) return;
    api.get(`/users/${slug}/follow-state`)
      .then(({ data }) => setState(data))
      .catch(() => {});
  }, [slug, user?.user_id]);

  const toggle = async () => {
    if (!user) { toast.error("Sign in to follow readers."); return; }
    if (state.is_self) return;
    setBusy(true);
    try {
      if (state.is_following) {
        await api.delete(`/users/${slug}/follow`);
        setState((s) => ({ ...s, is_following: false, followers_count: Math.max(0, s.followers_count - 1) }));
      } else {
        await api.post(`/users/${slug}/follow`);
        setState((s) => ({ ...s, is_following: true, followers_count: s.followers_count + 1 }));
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not update follow.");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="follow-block" className="flex items-center gap-4">
      <div className="mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
        <span data-testid="follow-followers">{state.followers_count}</span> follower{state.followers_count === 1 ? "" : "s"}
        {" · "}
        <span data-testid="follow-following">{state.following_count}</span> following
      </div>
      {!state.is_self && (
        <button
          data-testid="follow-toggle"
          onClick={toggle}
          disabled={busy}
          className={`mono text-[10px] uppercase tracking-[0.2em] px-4 py-2 transition-colors inline-flex items-center gap-2 disabled:opacity-50
            ${state.is_following
              ? "border border-[hsl(var(--primary))] text-[hsl(var(--primary))] hover:bg-[hsl(var(--destructive)/0.1)] hover:text-[hsl(var(--destructive))] hover:border-[hsl(var(--destructive))]"
              : "btn-gold"}`}
        >
          {state.is_following ? <UserCheck size={12} /> : <UserPlus size={12} />}
          {state.is_following ? "Following" : "Follow"}
        </button>
      )}
    </div>
  );
}
